import React, { useState } from "react";
import { Outlet } from "react-router-dom";

// import DashboardNavbar from "./DashboardNavbar";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Stack } from "@mui/material";
import { getUserType } from "../hooks/useLocalStorage";
import Header from "../SuperAdmin/Sidebar/Header";
import PageNotFound from "../error/PageNotFound";
import SessionValidate from "../middleware/SessionValidate";

const ProtectedSuperAdminLayout = () => {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(true);
  const drawerWidth = 240;

  const userType = getUserType();

  const Main = styled("main", {
    shouldForwardProp: (prop) => prop !== "drawerOpen",
  })(({ theme, drawerOpen }) => ({
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(drawerOpen && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }));

  return (
    <SessionValidate userType={userType}>
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        {userType === "superadmin" ? (
          <>
            <Header drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
            <Main drawerOpen={drawerOpen}>
              <Outlet context={{ drawerOpen }} />
            </Main>
          </>
        ) : (
          <>
            <Stack direction="row" sx={{ flexGrow: 1 }}>
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  p: 1,
                  overflowY: "auto",
                }}
              >
                <PageNotFound />
              </Box>
            </Stack>
          </>
        )}
      </Box>
    </SessionValidate>
  );
};

export default ProtectedSuperAdminLayout;
